import React from 'react';
import Slider, { Settings } from 'react-slick';
import ProductLink from '../models/ProductLink';
import ProductLinkCard from './ProductLinkCard';
import { isBrowser } from '@/utils/environment';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';
import { Carousel } from '@gik/ui';

interface ProductCarouselProps {
  productLinks: ProductLink[];
  title: string;
}

export default function ProductCarousel({ productLinks, title }: ProductCarouselProps) {
  const isLg = useBreakpoint(Breakpoint.LG);
  const [slidesToShow, setSlidesToShow] = React.useState<number>(4);

  React.useEffect(() => {
    if (isBrowser()) {
      setSlidesToShow(isLg ? 3 : window.innerWidth / 220);
    }
  }, [isLg]);

  const settings: Settings = {
    slidesToShow,
    infinite: false,
    autoplay: false,
    speed: 750,
    slidesToScroll: 1,
  };
  return (
    <div className="product-carousel">
      <p className="title">{title}</p>
      <Carousel {...settings}>
        {productLinks.map(productLink => (
          <ProductLinkCard key={productLink.title} productLink={productLink} />
        ))}
      </Carousel>
    </div>
  );
}
